<template>
  <div>
    <div class="md-card-avatar logoContainer">
      <img :src="src" class="logo" :style="isDefaultImage ? `height: 50%;` : ``" alt="logo" />
    </div>
    <div class="avatar-edit" v-if="enableUpload">
      <input
        type="file"
        id="imageUpload"
        @change="uploadImage($event)"
        accept=".png, .jpg, .jpeg"
      />
      <label for="imageUpload">
        <md-icon>add_a_photo</md-icon>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplicationLogo",
  props: ["application_id", "enableUpload"],
  data() {
    return {
      src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAAB+BAMAAAAQDbi7AAAAGFBMVEUAAAAaM4AQOnsUNoATN4AUOIAUOH////8H8/TlAAAABnRSTlMACh80XJoJ2n23AAAAAWJLR0QHFmGI6wAAAGhJREFUWMPt2LENgDAMBVHvkBEQAwSkbMACiLAAgv1HoL06KX3X/rzaUuJDT6Abw8uhkYRer9frc/odVT5bMGwcCkmYmVnOOjo5HBguDiuJ91uv1+uT+tn7YWZmOZv9v/J+6/V6vX7A/2+QkvtLKmPLAAAAAElFTkSuQmCC",
      isDefaultImage: true,
    };
  },
  methods: {
    uploadImage: function(event) {
      let data = new FormData();
      data.append("application_pk", this.application_id);
      data.append("logo", event.target.files[0]);
      this.isDefaultImage = false;
      let url =
        this.$store.state.server_address + "api/v1/dashboard/application-logo/";
      let headers = {
        Authorization: this.$store.getters.getAccessToken
      };
      fetch(url, {
        method: "POST",
        headers: headers,
        body: data
      }).then(response => {
        if (response.status === 201) {
          const image = event.target.files[0];
          const reader = new FileReader();
          reader.readAsDataURL(image);
          reader.onload = e => {
            this.src = e.target.result;
          };
        }
      });
    }
  },
  mounted() {
    let url =
      this.$store.state.server_address +
      "api/v1/dashboard/application-logo/?application_pk=" +
      this.application_id;
    let headers = {
      Authorization: this.$store.getters.getAccessToken
    };
    fetch(url, {
      method: "GET",
      headers: headers
    }).then(response => {
      if (response.status === 200) {
        let reader = response.body.getReader();
        reader.read().then(body => {
          this.src = `data:image/png;base64, ${Buffer.from(
            body.value,
            "binary"
          ).toString("base64")}`;
        });
      }
    });
  }
};
</script>

<style lang="scss" scoped>

.logoContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 128px;
  justify-content: center;
  background-color: white;
}
.logo {
  position: relative;
  object-fit: contain;
}

.avatar-edit {
  position: relative;
  right: -50px;
  z-index: 10;
  top: -115px;

  input {
    display: none;

    + label {
      display: inline-block;
      width: 34px;
      height: 34px;
      margin-bottom: 0;
      border-radius: 100%;
      background: #ffffff;
      border: 1px solid transparent;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
      cursor: pointer;
      font-weight: normal;
      transition: all 0.2s ease-in-out;

      &:hover {
        background: #f1f1f1;
        border-color: #d6d6d6;
      }
    }
  }

  label {
    .md-icon {
      margin-top: 3px;
    }
  }
}
</style>
